import { render, staticRenderFns } from "./TourChat.vue?vue&type=template&id=32170fb0&scoped=true&"
import script from "./TourChat.vue?vue&type=script&lang=js&"
export * from "./TourChat.vue?vue&type=script&lang=js&"
import style0 from "./TourChat.vue?vue&type=style&index=0&id=32170fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32170fb0",
  null
  
)

export default component.exports